module.exports = __webpack_public_path__ + "img/Si-barrier-Model.0ab1f96d.svg";